import { SVGProps } from "react";

export default function SolanaChainIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "24"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M19.9999 3.5H5.49992C5.18992 3.5 4.88993 3.65 4.69993 3.9L3.19993 5.9C2.70993 6.56 3.17992 7.5 3.99992 7.5H18.4999C18.8099 7.5 19.1099 7.35 19.2999 7.1L20.7999 5.1C21.2899 4.44 20.8199 3.5 19.9999 3.5Z"
        fill="white"
      />
      <path
        d="M3.99992 10H18.4999C18.8099 10 19.1099 10.15 19.2999 10.4L20.7999 12.4C21.2899 13.06 20.8199 14 19.9999 14H5.49992C5.18992 14 4.88993 13.85 4.69993 13.6L3.19993 11.6C2.70993 10.94 3.17992 10 3.99992 10Z"
        fill="white"
      />
      <path
        d="M19.9999 16.5H5.49992C5.18992 16.5 4.88993 16.65 4.69993 16.9L3.19993 18.9C2.70993 19.56 3.17992 20.5 3.99992 20.5H18.4999C18.8099 20.5 19.1099 20.35 19.2999 20.1L20.7999 18.1C21.2899 17.44 20.8199 16.5 19.9999 16.5Z"
        fill="white"
      />
    </svg>
  );
}
